import { render } from "./VersionHistoryModal.vue?vue&type=template&id=439a77ad&scoped=true"
import script from "./VersionHistoryModal.vue?vue&type=script&lang=js"
export * from "./VersionHistoryModal.vue?vue&type=script&lang=js"

import "./VersionHistoryModal.vue?vue&type=style&index=0&id=439a77ad&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439a77ad"]])

export default __exports__